import { Controller } from "@hotwired/stimulus"

import { isGoogleVignetteShowing } from "../services/google_vignette"

// Opens the popup <dialog> it sits on (see shared/popups) when a global
// "popup:show" event names it. Trigger one from anywhere with
//   this.dispatch("show", { prefix: "popup", target: window, detail: { name } })
// Closing is native: Escape and the method="dialog" buttons in the markup.
export default class extends Controller<HTMLDialogElement> {
  static values = { name: String }

  declare readonly nameValue: string

  show(event: CustomEvent<{ name?: string }>) {
    if (event.detail?.name !== this.nameValue) return
    if (isGoogleVignetteShowing()) return

    // showModal() on an already-open dialog throws InvalidStateError.
    if (!this.element.open) this.element.showModal()
  }

  // Turbo must not snapshot an open dialog — the restored copy would render
  // outside the top layer as a stuck inline box (see turbo:before-cache action).
  // Turbo also snapshots on every in-page address change, which is what closes
  // the popup when Google's vignette ad parks the page on #google_vignette.
  close() {
    this.element.close()
  }
}
